import React from 'react'

const CourseCard = ({ course = { image: "", category: "", title: "", description: "", lecons: 34, heures: 54 } }) => {
    return (
        <li>
            <a href="course-intro.html">
                <div className="course-card">
                    <div className="course-card-thumbnail ">
                        <img src={course.image} />
                        <span className="play-button-trigger"></span>
                    </div>
                    <div className="course-card-body">
                        <div className="course-card-info">
                            <div>
                                <span className="catagroy">{course.category}</span>
                            </div>
                            <div>
                                <i className="icon-feather-bookmark icon-small"></i>
                            </div>
                        </div>

                        <h4>{course.title}</h4>
                        <p> {course.description}</p>

                        <div className="course-card-footer">
                            <h5> <i className="icon-feather-film"></i> {course.lecons ?? 34} Leçons </h5>
                            <h5> <i className="icon-feather-clock"></i> {course.heures ?? 54} Heures </h5>
                        </div>
                    </div>

                </div>
            </a>
        </li>

    )
}

export default CourseCard
